import { render, staticRenderFns } from "./Buyers.vue?vue&type=template&id=a0d55690&scoped=true&"
import script from "./Buyers.vue?vue&type=script&lang=js&"
export * from "./Buyers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d55690",
  null
  
)

export default component.exports